/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pIndexListItem.vue?vue&type=template&id=dd77549e&scoped=true"
import script from "./pIndexListItem.vue?vue&type=script&lang=js"
export * from "./pIndexListItem.vue?vue&type=script&lang=js"
import style0 from "./pIndexListItem.vue?vue&type=style&index=0&id=dd77549e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd77549e",
  null
  
)

export default component.exports